export const fileServer = 'https://files.thehivelms.com';
export const prodBackend = 'https://funnel.quility.com:3333';
export const funnelErrorArticles = 'https://funnel-help.quility.com';